module.exports = __webpack_public_path__ + "img/success.fc804f4a.png";